import { mapEntityProperties } from '@/utils/mapEntityProperties'
import moment from 'moment'
import { dayOfWeekOrder } from '@/shared/enums/DayOfWeekOrder'
import { PostCompanyOrderPeriodRequestEntity } from '../../domain/entities/PostCompanyOrderPeriodRequestEntity'

export class CompanyOrderPeriodModel extends PostCompanyOrderPeriodRequestEntity {
  constructor(dataDto: PostCompanyOrderPeriodRequestEntity) {
    super()

    // Calculate day of week for time
    const dayOfWeek = dataDto.timeDayOfWeek || dataDto.dayOfWeek

    // Handle time formatting
    const formattedTime = dataDto.time
      ? moment.utc(dataDto.time).isValid()
        ? moment.utc(dataDto.time).format('HH:mm')
        : moment.utc(moment(dataDto.time, 'HH:mm').format('')).format('HH:mm')
      : undefined

    // Calculate day of week changes for UTC conversion
    let timeDayOfWeek = dataDto.timeDayOfWeek

    if (dataDto.time && dayOfWeek) {
      const timeLocal = moment(dataDto.time, 'HH:mm')
      const timeUtc = moment(timeLocal).utc()

      // If UTC day differs from local day
      if (timeLocal.format('dddd') !== timeUtc.format('dddd')) {
        const dayIndex = dayOfWeekOrder.findIndex((day) => day === dayOfWeek)
        const previousDay =
          dayOfWeekOrder[dayIndex - 1] || dayOfWeekOrder[dayOfWeekOrder.length - 1]
        timeDayOfWeek = previousDay
      }
    }

    mapEntityProperties<CompanyOrderPeriodModel>(this, {
      id: dataDto.id,
      time: formattedTime,
      timeDayOfWeek: timeDayOfWeek,
      dayOfWeek: dataDto.dayOfWeek
    })
  }
}
